import * as React from 'react';
const SvgLive = (props) => (
  <svg viewBox="0 0 152 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M150 93.2h-16.709V122M142.838 122H150M133.291 107.6h9.548M68.838 93.2V122h14.323M92.71 93.2V122M102.258 93.2 113 122l10.742-28.8M40.193 46.4V92l38.194-22.8-38.194-22.8Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.516 122C25.513 122 2 98.36 2 69.2c0-29.16 23.513-52.8 52.516-52.8 29.003 0 52.516 23.64 52.516 52.8"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.516 30.8c21.096 0 38.194 17.19 38.194 38.4M54.516 2c36.917 0 66.839 30.084 66.839 67.2"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgLive;
